import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { Constants } from "@constants";
import { IPiramidePoblacionalDTO, PiramidePoblacionalDTO } from "@DTOS";

@Injectable({
    providedIn: "root"
})
export class PiramidePoblacionalServiceBackend {

    constructor(private httpClient: HttpClient) {}

    public getPyramid(pais: string): Observable<PiramidePoblacionalDTO[]> {
        return this.httpClient
            .get<IPiramidePoblacionalDTO[]>(`${Constants.apiURL}/population-pyramids`, {params: {country: pais}})
            .pipe(
                map(filas => filas.map(fila => new PiramidePoblacionalDTO(fila))),
                catchError(() => of([]))
            );
    }

    public getPyramids(): Observable<PiramidePoblacionalDTO[]> {
        return this.httpClient.get<IPiramidePoblacionalDTO[]>(`${Constants.apiURL}/population-pyramids`)
            .pipe(
                map(filas => filas.map(fila => new PiramidePoblacionalDTO(fila))),
                catchError(() => of([]))
            );
    }

    public postPyramid(filasPiramide: Array<PiramidePoblacionalDTO>): Observable<PiramidePoblacionalDTO[]> {
        const filasJSON = filasPiramide.map(fila => fila.toJSON());
        return this.httpClient.post<IPiramidePoblacionalDTO[]>(
            `${Constants.apiURL}/population-pyramids`,
            filasJSON
        ).pipe(
            map(filas => filas.map(fila => new PiramidePoblacionalDTO(fila))),
            catchError(() => of([]))
        );
    }

    public putPyramid(filasPiramide: Array<PiramidePoblacionalDTO>): Observable<PiramidePoblacionalDTO[]> {
        const filasJSON = filasPiramide.map(fila => fila.toJSON());

        return this.httpClient.put<IPiramidePoblacionalDTO[]>(
            `${Constants.apiURL}/population-pyramids`,
            filasJSON
        ).pipe(
            map(filas => filas.map(fila => new PiramidePoblacionalDTO(fila))),
            catchError(() => of([]))
        );
    }

    public deletePyramid(pais: string): Observable<boolean> {
        return this.httpClient.delete<boolean>(
            `${Constants.apiURL}/population-pyramids/${pais}`).pipe(
            map(() => true),
            catchError(() => of(false))
        );
    }
}
